export default "__VITE_ASSET__CMBU0lzC__"